import React, { createContext, useState, useContext } from "react";

const CheckoutContext = createContext();

export const useCheckout = () => useContext(CheckoutContext);

export const CheckoutProvider = ({ children }) => {
  const [checkoutMode, setCheckoutMode] = useState(null); // 'guest' or 'member'

  return (
    <CheckoutContext.Provider value={{ checkoutMode, setCheckoutMode }}>
      {children}
    </CheckoutContext.Provider>
  );
};
